import { DEMAND_TYPES, RECRUITMENT_TYPES } from "@core/constants";
import { IRecruitment, RecruitmentAEModel, RecruitmentPermanentModel } from "@core/models";

export const basicRecruitmentCDIMock = new RecruitmentPermanentModel({
  [IRecruitment.qualificationLabel]: "Serveur",
  [IRecruitment.demandType]: DEMAND_TYPES.CDI.toLowerCase(),
});

export const basicRecruitmentAEMock = new RecruitmentAEModel({
  [IRecruitment.type]: RECRUITMENT_TYPES.TEMPORARY.shortLabel,
  [IRecruitment.demandType]: DEMAND_TYPES.AE,
});
